

import { baseUrl_SPB} from '../BaseUrl';
export default  async function AddInviteService(formData, token) {
     let tokenv=token.toString();
              const payload = {
          ...formData,
          locationId: formData?.locationId ?? null,
      };
        try {
            const response = await fetch(`${baseUrl_SPB}/api/v1/invite/inviteandsave`, {
                method: 'POST',

                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + tokenv
                },
                body: JSON.stringify(payload),
            });
            const jsonResponse = await response.json();
            return jsonResponse;
            return jsonResponse;

        } catch (error) {
            console.error('Error:', error);
        }
    }
   



